/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'ca-ui-toolkit',
	'../VisualItem',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/information_16'
], function(
	React,
	PropTypes,
	UI_Toolkit,
	VisualItem,
	StringResources,
	Information_16
) {

	const { FlexLayout, FlexItem, VSpacer, HSpacer, Flyout, Label } = UI_Toolkit;

	class PreviewVisualItem extends VisualItem {

		constructor(props) {
			super(props);
			this.state.sdkIsRunning = false;
			this._initRenderContext(this.state.sdkIsRunning);
		}

		_initRenderContext(sdkIsRunning) {
			const { item } = this.state;
			const { handlers, iconsFeature } = this.props;
			const isSchematicType = handlers.isSchematicType(item);

			let icon;
			if (isSchematicType) {
				icon = iconsFeature.getIcon('svgFile').id;
			} else {
				icon = iconsFeature.getIcon('codeFile').id;
			}

			this._renderContext = {
				icon: icon,
				description: isSchematicType ? item.label : StringResources.get('customVisTestVisualization'),
				isDisabled: isSchematicType ? false : (sdkIsRunning ? false : true)
			};
		}

		_isSDKActive() {
			return this.props.handlers.isSDKActive();
		}

		componentDidMount() {
			super.componentDidMount();
			return this._isSDKActive()
				.then(sdkIsRunning => {
					if ( sdkIsRunning ) {
						this._initRenderContext(true);
						this.setState({
							sdkIsRunning: true
						});
						this._attachCallbacksAndImages();
					}
				}).catch(() => {
					// swallow it... sdk is not running and that's fine
				});
		}

		componentWillUnmount () {
			super.componentWillUnmount();
		}

		_getVisualItemCssClasses () {
			return super._getVisualItemCssClasses() + ' vis-custom-preview';
		}

		_canRenderMenuOption () {
			return this._renderContext.isDisabled ? true : false;
		}

		_getContextMenuContent () {
			return (
				<Flyout
					theme={true}
					placement='bottomRight'
					showX={true}
					triggerNode={this.target}
					domNodeToAttachTo={document.body}
					onClose={this.onClose.bind(this)}
					className='vis-preview-indicator-menu'
				>
					<FlexLayout
						fullHeight
						direction='row'
						justifyContent='flex-start'
					>
						<FlexItem>
							<HSpacer size={2} />
						</FlexItem>
						<FlexItem>
							<FlexLayout
								fullHeight
								direction='column'
								justifyContent='flex-start'
							>
								<FlexItem>
									<VSpacer size={2} />
								</FlexItem>
								<FlexItem>
									<Label
										label={StringResources.get('extVisNoSDKConnection')}
										className='vis-preview-indicator-menu-title'
									/>
								</FlexItem>
								<FlexItem>
									<VSpacer size={2} />
								</FlexItem>
								<FlexItem>
									<Label
										label={StringResources.get('extVisNoSDKPreviewMsg')}
										className='vis-preview-indicator-menu-msg'
									/>
								</FlexItem>
								<FlexItem>
									<VSpacer size={2} />
								</FlexItem>
							</FlexLayout>
						</FlexItem>
						<FlexItem>
							<HSpacer size={2} />
						</FlexItem>
					</FlexLayout>
				</Flyout>
			);
		}
	}

	PreviewVisualItem.propTypes = {
		item: PropTypes.object.isRequired,
		handlers: PropTypes.shape({
			componentDidMountCallback: PropTypes.func.isRequired,
			componentWillUnmountCallback: PropTypes.func.isRequired,
			isSchematicType: PropTypes.func.isRequired,
			isSDKActive: PropTypes.func.isRequired
		}).isRequired,
		menuIcon: PropTypes.object
	};

	PreviewVisualItem.defaultProps = {
		menuIcon: Information_16
	};

	return PreviewVisualItem;
});
